import { render } from "./Signup.vue?vue&type=template&id=a0007976&scoped=true"
import script from "./Signup.vue?vue&type=script&lang=js"
export * from "./Signup.vue?vue&type=script&lang=js"

import "./Signup.vue?vue&type=style&index=0&id=a0007976&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Z\\Desktop\\7\\vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0007976"]])

export default __exports__